import React from 'react'
import ButtonsContainer from '../../Components/Buttons'

export default function Buttons() {
    return (
        <div className='page-body'>
            <ButtonsContainer />
        </div>
    )
}
